exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.room-blocked[data-v-0a2cb076] {\n  opacity: .65;\n}\n.room-blocked-reason[data-v-0a2cb076] {\n  margin: 0;\n  font-weight: 600;\n  font-style: italic;\n  color: #888;\n}\n", ""]);

// exports
